import React, { Component } from 'react';
import { size, each, filter, groupBy, includes, isEqual, uniq } from 'lodash';
import { connect } from 'react-redux';
import { Tag } from 'antd';

import IntlMessages from 'util/IntlMessages';

import OpenNotification from '../common/CommonButton/OpenNotification';
import { currentPageData } from 'appRedux/actions/Common';
import { hasKey } from 'util/utils';

let selectedCarat = {};

class Carat extends Component {
  constructor(props) {
    super(props);
    this.state = {
      From: '',
      To: '',
      showTag: false,
      tagsState: [],
      caratUI: false,
      selected: {},
      selectAll: false,
      caratSizeGroup: {},
      carats: [],
      focus: false,
    };
  }

  focusLabel = () => {
    this.setState({ focus: !this.state.focus });
  };

  componentDidMount() {
    selectedCarat = {};
    this.setState({ selected: {} });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.commonData.reset && nextProps.commonData.reset.searchReset) {
      this.setState({ selected: {}, tagsState: [], showTag: false, From: '', To: '' });
      selectedCarat = {};
    }

    if (!isEqual(nextProps.data, this.props.data)) {
      this.setState({ carats: nextProps.data, caratSizeGroup: groupBy(nextProps.data, 'group') });
    }

    if (nextProps.commonData.modifySearch && nextProps.commonData.modifySearch['or']) {
      if (this.props.commonData.modifySearch !== nextProps.commonData.modifySearch) {
        let or = nextProps.commonData.modifySearch['or'];
        let modifyData = or.filter((el) => hasKey(el, 'crt'));
        let wholeData = groupBy(nextProps.data, 'group');

        /**
         * simiplify and uniquify filtered carat data
         */
        let modifyArr = modifyData.map((val) => val.crt['>='] + '-' + val.crt['<=']);
        modifyArr = uniq(modifyArr);

        /**
         * seprate the ranges that are match our wholeData(default carats ranges)
         */
        let temp = {};
        Object.keys(wholeData).map((key) => {
          let data = wholeData[key].filter((val) => modifyArr.indexOf(val.webDisplay) !== -1);
          if (data.length) {
            temp[key] = data.map((x) => x.webDisplay);
            return true;
          } else {
            return false;
          }
        });

        /**
         * remove separated ranges from modifyArr to indentify custom ranges of carat
         */
        each(temp, (val, key) => {
          temp[key].map((val1) => {
            modifyArr = filter(modifyArr, (value) => {
              return value !== val1;
            });
            return true;
          });
        });
        selectedCarat = temp;
        this.setState({ selected: temp }, () => {
          this.props.selectedCaratFn(this.state.selected);
        });
        this.setState({ tagsState: modifyArr, showTag: true }, () => {
          this.props.selectedCaratFn(this.state.tagsState);
        });
      }
    }
  }

  async handleAddCarat() {
    if (
      this.state.From &&
      this.state.To &&
      parseInt(this.state.From) <= parseInt(this.state.To) &&
      !includes(this.state.tagsState, this.state.From + '-' + this.state.To)
    ) {
      this.setState(
        (prevState) => ({
          tagsState: prevState.tagsState.concat(this.state.From + '-' + this.state.To),
        }),
        () => {
          this.props.selectedCaratFn(this.state.tagsState);
        },
      );
      return this.setState({ showTag: true, From: '', To: '' });
    } else if (
      this.state.From &&
      this.state.To &&
      includes(this.state.tagsState, this.state.From + '-' + this.state.To)
    ) {
      OpenNotification({
        type: 'success',
        title: 'Carat range is already added.',
      });
    } else if (this.state.From && this.state.To && parseInt(this.state.From) > parseInt(this.state.To)) {
      OpenNotification({
        type: 'error',
        title: 'To must be greater than from.',
      });
    }
    await this.setState({ From: '', To: '' });
  }

  onTagClose(tagInput) {
    this.setState(
      (prevState) => ({
        tagsState: prevState.tagsState.filter((x) => x !== tagInput),
      }),
      () => {
        this.props.selectedCaratFn(this.state.tagsState, tagInput);
      },
    );
  }

  handleCaratSelection = ([key, list]) => {
    const checked = size(this.state.selected[key]) < 1;
    const group = list.map((range) => range.webDisplay);
    checked ? void (selectedCarat[key] = group) : delete selectedCarat[key];

    this.setState({ selected: selectedCarat }, () => {
      this.props.selectedCaratFn({ [key]: group }, { checked, key });
    });
  };

  showCaratRanges() {
    this.setState({ caratUI: !this.state.caratUI });
  }

  render() {
    const { caratSizeGroup = {} } = this.state;

    return (
      <div className="diamondSearchItem">
        <div className="diamondSearchLabel">
          <label>
            <IntlMessages id="app.carat-range" />
          </label>
        </div>
        <div className="diamondSearchDetail">
          <div className=" d-flex align-items-center flex-wrap">
            <div className="diamondSearchCaratRange">
              <div className="fromToValue">
                <div className={`fromToValueInput ${this.state.focus && 'focus'}`}>
                  <label>
                    <IntlMessages id="app.from" />
                  </label>
                  <input
                    onClick={this.focusLabel}
                    type="number"
                    value={this.state.From}
                    onChange={(e) => this.setState({ From: e.target.value })}
                  />
                </div>
                <div className="fromToValueInput">
                  <label>
                    <IntlMessages id="app.to" />
                  </label>
                  <input
                    onKeyPress={(e) => {
                      if (e.key === 'Enter') this.handleAddCarat();
                    }}
                    type="number"
                    value={this.state.To}
                    onChange={(e) => this.setState({ To: e.target.value })}
                    onBlur={this.handleAddCarat.bind(this)}
                  />
                </div>
              </div>
            </div>
            <div className="commonButton addCaratButton" onClick={this.handleAddCarat.bind(this)}>
              <img src={require('assets/svg/plus-white.svg')} className="defaultImage" alt="plus" />
              <img src={require('assets/svg/DiamondList/plus-color.svg')} className="hoverImg" alt="plus" />
            </div>
            <a href="#parameter" onClick={this.props.onClick} className="commonOutline addCaratButton">
              <img src={require('assets/svg/DiamondList/plus-color.svg')} className="defaultImage" alt="plus" />
              <img src={require('assets/svg/plus-white.svg')} className="hoverImg" alt="plus" />
              <span> MM</span>
            </a>
          </div>
          <div className="caratTagButton">
            {this.state.showTag &&
              this.state.tagsState.map((tagInput) => {
                return (
                  <Tag className="addedCarat" key={tagInput} onClose={this.onTagClose.bind(this, tagInput)} closable>
                    {tagInput}
                  </Tag>
                );
              })}
          </div>
          <ul className="diamondSearchList mt-10">
            {Object.entries(caratSizeGroup).map((entry, index) => {
              const [value] = entry;
              const label = Object.keys(caratSizeGroup).length - 1 === index ? `${value?.split?.(' - ')?.[0]}+` : value;

              return (
                <li
                  key={label}
                  onClick={this.handleCaratSelection.bind(this, entry)}
                  className={`${this.state.selected[value] ? 'active' : ''}`}
                >
                  {label}
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (props) => {
  return props;
};
export default connect(mapStateToProps, { currentPageData })(Carat);
